import { render, staticRenderFns } from "./SlimProgressBar.vue?vue&type=template&id=a31aada6&scoped=true"
import script from "./SlimProgressBar.vue?vue&type=script&lang=js"
export * from "./SlimProgressBar.vue?vue&type=script&lang=js"
import style0 from "./SlimProgressBar.vue?vue&type=style&index=0&id=a31aada6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a31aada6",
  null
  
)

export default component.exports